



































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { FilterGroup } from '@/models/reports/filter-group';
import { Filter } from '@/models/reports/filter';
import { namespace, Getter } from 'vuex-class';
import { Operator } from '@/models/reports/report-operators';
import reportFilter from '@/components/reports/report-filter.vue';
import { SelectItem } from '@/models/reports/select-item';
const ReportModule = namespace('report');

@Component({
    components: {
        reportFilter,
    },
})
export default class ReportFilterGroup extends Vue {
    @Prop({ required: true }) public filterGroup!: FilterGroup;
    @ReportModule.Getter public allReportLogicalOperators!: Array<SelectItem>;
    private tempFilterGroup: FilterGroup = this.filterGroup;

    @Watch('filterGroup')
    private filterGroupChange(filterGroup: FilterGroup) {
        this.tempFilterGroup = filterGroup;
    }

    public addFilter() {
        this.$emit('add-filter', this.tempFilterGroup);
    }

    public removeFilter(filter: Filter) {
        const filterIndex = this.tempFilterGroup.filters.findIndex((x) => x.id === filter.id);
        if (filterIndex === -1) {
            return;
        }

        if (this.tempFilterGroup.filters.length === 1) {
            filter.clear();
            this.tempFilterGroup.filters.splice(filterIndex, 1, filter);
            return;
        }
        this.tempFilterGroup.filters.splice(filterIndex, 1);
    }

    public remove() {
        this.$emit('remove-filter-group', this.tempFilterGroup.id);
    }

    private openFieldSelector(filter: Filter): void {
        this.$emit('open-field-selector', filter);
    }
}
